import { useEffect, useState } from "react";
import { LiaHornbill, LiaSearchPlusSolid } from "react-icons/lia";
import { MdClose } from "react-icons/md";
import { orderPlanView, salesOrderMaster } from "../../utlis/apiService";
import { notify } from "../../common/Toast";
import Loader from "../../common/Loader";
import Table from "../../common/Table";
import Pagination from "../../common/Pagination";
import BatchTable from "./BatchTable";
import Button from "../../common/Button";

const OrderPlanView = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [isOrderplanData, setIsOrderPlanData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const pageSize = 10;
  const [selectedIds, setSelectedIds] = useState([]);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [batchItems, setBatchItems] = useState([]);
  const [batchId, setBatchId] = useState("");

  const fetchOrderplanData = async () => {
    setLoading(true);
    try {
      const res = await orderPlanView.getAllPlanOrders(currentPage, pageSize);
      setIsOrderPlanData(res.data || []);
      setFilteredData(res.data || []);
      setTotalRecords(res.totalRecords || res.data?.length || 0);
    } catch (error) {
      notify("Error fetching Order Plan data", "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchOrderplanData();
  }, [currentPage]);

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredData(isOrderplanData);
    } else {
      const filtered = isOrderplanData.filter((d) =>
        d.status_Name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredData(filtered);
    }
  }, [searchQuery, isOrderplanData]);

  const columns = [
    {
      key: "select",
      label: (
        <input
          type="checkbox"
          checked={
            filteredData.length > 0 &&
            selectedIds.length ===
              filteredData.filter((i) => i?.id).map((i) => i.id).length
          }
          onChange={(e) => {
            if (e.target.checked) {
              const allIds = filteredData.filter((i) => i?.id).map((i) => i.id);
              setSelectedIds(allIds);
            } else {
              setSelectedIds([]);
            }
          }}
        />
      ),
      render: (_value, row) =>
        row?.id ? (
          <input
            type="checkbox"
            checked={selectedIds.includes(row.id)}
            onChange={() => {
              setSelectedIds((prev) =>
                prev.includes(row.id)
                  ? prev.filter((id) => id !== row.id)
                  : [...prev, row.id]
              );
            }}
          />
        ) : null,
    },
    { key: "order_No", label: "SO NO" },
    { key: "cust_Name", label: "Customer" },
    { key: "dieNumber", label: "Die no" },
    { key: "currentWeight", label: "Current Weight" },
    { key: "profile_Length", label: "Cut Length" },
    { key: "qty", label: "Pcs" },
    { key: "qty_Weight", label: "Weight" },
    { key: "alloy_Name", label: "Alloy" },
    { key: "req_Delivery", label: "Req. Delivery" },
    { key: "status", label: "Status" },
  ];

  return (
    <>
      <div className="rounded-md bg-white shadow-md border px-5 pt-6 pb-2.5 mt-10 ">
        <div className="flex flex-col sm:flex-row justify-between items-center mb-6 gap-4">
          <div className="flex items-center space-x-2">
            <h2 className="text-2xl font-semibold text-slate-800 ">
              Production Planning from Sales Orders
            </h2>
          </div>
          <div className="flex flex-col sm:flex-row items-center gap-3 w-full sm:w-auto">
            <div className="relative ">
              <input
                type="text"
                className="w-full bg-gray-100 border border-gray-3 py-2 pl-10 pr-10 rounded-md focus:ring-1 focus:ring-primary focus:border-primary outline-none"
                placeholder="Search ..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <Button
                icon={LiaSearchPlusSolid}
                iconSize="w-5 h-5"
                className="absolute left-3 top-1/2 transform -translate-y-1/2 text-primary"
              ></Button>
              {searchQuery && (
                <Button
                  icon={MdClose}
                  onClick={() => setSearchQuery("")}
                  iconSize="w-5 h-5"
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-danger"
                ></Button>
              )}
            </div>
            <Button
              text={`Add To Batch (${selectedIds.length})`}
              icon={LiaHornbill}
              onClick={async () => {
                if (selectedIds.length === 0) return;
                try {
                  const res = await salesOrderMaster.AddToBatch({
                    SelectedIds: selectedIds,
                  });
                  setBatchItems(res || []);
                  setBatchId(res.batchId || "");
                  setIsModelOpen(true);
                } catch (err) {
                  notify("Failed to add to batch", "error");
                }
              }}
              className="bg-orange text-black font-semibold text-md rounded-md p-2"
              iconSpacing="pr-1"
              iconColor="text-black"
            />
          </div>
        </div>

        {loading ? (
          <Loader />
        ) : (
          <Table columns={columns} data={filteredData} showActions={false} />
        )}

        <div className="flex justify-center items-center mt-4">
          <Pagination
            currentPage={currentPage}
            totalPages={Math.ceil(totalRecords / pageSize)}
            onPageChange={setCurrentPage}
          />
        </div>
        {selectedIds.length > 0 && (
          <div className="border rounded-md bg-blue-50 border-blue-200 p-4">
            <p className="block text-md text-sky-600 font-semibold">
              Selected Items Summary:
            </p>
            <div className="mt-4 text-sky-600 font-medium grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div>
                <span className="block text-sm">Total Pieces:</span>
                <span className="text-2xl font-semibold text-sky-600">
                  {filteredData
                    .filter((item) => selectedIds.includes(item.id))
                    .reduce((sum, item) => sum + (Number(item.qty) || 0), 0)}
                </span>
              </div>
              <div>
                <span className="block text-sm">Total Estimated Weight:</span>
                <span className="text-2xl font-semibold text-sky-600">
                  {filteredData
                    .filter((item) => selectedIds.includes(item.id))
                    .reduce(
                      (sum, item) => sum + (Number(item.qty_Weight) || 0),
                      0
                    )
                    .toFixed(2)}{" "}
                  kg
                </span>
              </div>
            </div>
          </div>
        )}
        {isModelOpen && (
          <BatchTable
            batchItems={batchItems}
            batchId={batchId}
            onClose={() => {
              setIsModelOpen(false);
              fetchOrderplanData();
              setSelectedIds([]);
              setBatchItems([]);
              setBatchId("");
            }}
          />
        )}
      </div>
    </>
  );
};

export default OrderPlanView;
